import { render, staticRenderFns } from "./tree-category.vue?vue&type=template&id=3d235fdb&"
import script from "./tree-category.vue?vue&type=script&lang=js&"
export * from "./tree-category.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports